/**
 * Module definition and dependencies
 */
angular
  .module('App.MesProjets.Controller', [
    'transactionsService.Service'
  ])

  /**
   * Controller
   */
  .controller('MesProjetsCtrl', [
    'Transactions',
    '$scope',
    '$rootScope',
    '$state',
    function (Transactions, $scope, $rootScope, $state) {
      this.redirection = (transactions) => {
        if (transactions.length === 1) {
          return $state.go('monInvestissement', {
            id: transactions[0].id
          });
        }
      }
      $scope.$on('transactionsGet', () => {
        $scope.listTransactions = Transactions
          .getTransactions();
        this.redirection($scope.listTransactions);
      });

      this.$onInit = () => {
        $rootScope.stateParamsId = null;
        $scope.listTransactions = Transactions
          .getTransactions();
        this.redirection($scope.listTransactions);
      };
    },
  ]);
